var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hk-breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ name: 'HomePage' }}},[_vm._v("首页")]),_vm._l((_vm.links),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item.title))])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }